import { React, useRef, useState, useEffect } from "react";
import TextInput from "../../UIComponent/TextInput";
import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown";
import ValidationText from "../../../utils/validation/ValidationText";
import DateInput from "../../inputs/DateInput";
import RadioButton from "../membershipTaskList/RadioButton";
import NumberInput from "../../UIComponent/NumberInput";
import ImageCropperWithUpload from "../../ImageUpload/UploadImage";
import { APIURL, GetImage } from "../../../services/axiosServices/ApiEndPoints";
import moment from "moment";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
function BasicApplication(props) {
  const textRef = useRef();
  const [value] = useState();

  useEffect(() => {
    if (textRef && textRef.current) {
      textRef.current.style.height = "0px";
      const taHeight = textRef.current.scrollHeight;
      textRef.current.style.height = taHeight + "px";
    }
  }, [value]);

  return (
    <div className="w-full organisation-basic-information">
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="input-title mb-3">
                  Application For Tier <span className="text-[#c00000]">*</span>
                </h2>
                <MultiSelectDropdown
                  drpIdentity="Application_Tire"
                  options={props.applicationTierList}
                  // isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={props.handleChangeSelectorDropdown}
                  allowSelectAll={false}
                  value={props.applicationTierList.find(
                    (appTier) =>
                      appTier.value === props.basicApplicationDetails?.applicationTierId
                  )}

                />
              </div>
            </div>

          </div>
        </div>

        <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-12 mb-3">
          <div className="col-span-12">
            <div className="form-info-title">
              <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                Basic Application
              </h4>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-3 mb-3">
          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              First Name
              <span className="text-[#C00000]"> *</span>
            </h2>

            <div className="dropdown business-tel-no">
              {/* Row: Dropdown + Textbox */}
              <div className="inputname flex items-center left-border-none">
                <div className="textbox-one w-[130px] name-dropdown-position">
                  <MultiSelectDropdown
                    drpIdentity="MrMrsId"
                    options={props.mrMrsList}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    onChange={props.handleChangeSelectorDropdown}
                    allowSelectAll={false}
                    value={props.mrMrsList.find(
                      (role) =>
                        role.value === props.basicApplicationDetails.mrMrsId
                    )}
                  />
                </div>
                <TextInput
                  name="firstName"
                  value={props.basicApplicationDetails.firstName}
                  identity="Caps_Application"
                  handleChange={(e) =>
                    props.handleChange(e, "BasicApplication")
                  }
                //onBlur={() =>props.validateField("firstName", "Basic_Application")}
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Last Name
              <span className="text-[#C00000]"> *</span>
            </h2>

            <div className="dropdown">
              <TextInput
                placeholder=""
                name="lastName"
                value={props.basicApplicationDetails.lastName}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              //onBlur={() =>props.validateField("lastName", "Basic_Application")}
              />

            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Date of Birth
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <DateInput
                name="dateOfBirth"
                value={moment(
                  props.basicApplicationDetails.dateOfBirth
                ).format("YYYY-MM-DD")}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              //onBlur={() =>props.validateField("dateOfBirth", "Basic_Application")}
              />
              <ValidationText
              //   error={
              //     props.validStateBasicApplication.error
              //       .dateOfACRARegistration
              //   }
              />
            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              NRIC/Passport/Work Pass No. (Last 3 digit & alphabets)
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <TextInput
                placeholder=""
                name="NRIC_Passport_WorkPassNo"
                value={
                  props.basicApplicationDetails.NRIC_Passport_WorkPassNo
                }
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              //onBlur={() =>props.validateField("NRIC_Passport_WorkPassNo","Basic_Application")}
              />
            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts company-type">
            <h2 className="input-title mb-3">
              Sex
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="flex items-center w-full">
              <div className="flex items-center">
                <RadioButton
                  id="isSexMale"
                  name="isSexMale"
                  className="form-radio-caps"
                  value={true}
                  checked={props.basicApplicationDetails.isSexMale === true}
                  handleRadioButtons={(e) =>
                    props.handleChange(e, "Basic_Application_Radio")
                  }
                />
                <span className="ml-3">Male</span>
              </div>
              <div className="flex items-center ml-10">
                <RadioButton
                  id="isSexMale"
                  name="isSexMale"
                  className="form-radio-caps"
                  value={false}
                  checked={
                    props.basicApplicationDetails.isSexMale === false
                  }
                  handleRadioButtons={(e) =>
                    props.handleChange(e, "Basic_Application_Radio")
                  }
                />
                <span className="ml-3">Female</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Mailing Address Line 1<span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <TextInput
                placeholder=""
                name="mailingAddressLine1"
                value={props.basicApplicationDetails.mailingAddressLine1}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              //onBlur={() =>
              //props.validateField(
              //  "mailingAddressLine1",
              //  "Basic_Application"
              // )
              //}
              />

            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Mailing Address Line 2<span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <TextInput
                placeholder=""
                name="mailingAddressLine2"
                value={props.basicApplicationDetails.mailingAddressLine2}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              />

            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Mailing Address Line 3<span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <TextInput
                placeholder=""
                name="mailingAddressLine3"
                value={props.basicApplicationDetails.mailingAddressLine3}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
              />

            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Postal Code
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <NumberInput
                placeholder=""
                name="postalCode"
                value={props.basicApplicationDetails.postalCode}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
                onBlur={() => { }}
              />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="input-title mb-3">
                  Country <span className="text-[#c00000]">*</span>
                </h2>
                <MultiSelectDropdown
                  drpIdentity="Selected_Country"
                  options={props.countryList}
                  // isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={props.handleChangeSelectorDropdown}
                  allowSelectAll={false}
                  value={props.countryList.filter(
                    (country) =>
                      country.value ===
                      props.basicApplicationDetails.countryId
                  )}
                />
              </div>
            </div>
            {/* <Validation error={props.validState.error.projectTypeId} /> */}
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Contact Number
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <NumberInput
                placeholder=""
                name="contactNumber"
                value={props.basicApplicationDetails.contactNumber}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
                onBlur={() => { }}
              />
            </div>
          </div>

          <div className="lg:col-span-6 col-span-12 input-sec-texts">
            <h2 className="input-title mb-3">
              Personal Email Address
              <span className="text-[#C00000]"> *</span>
            </h2>
            <div className="dropdown">
              <TextInput
                name="emailAddress"
                value={props.basicApplicationDetails.emailAddress}
                identity="Caps_Application"
                handleChange={(e) =>
                  props.handleChange(e, "BasicApplication")
                }
                disabled={true}
                className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
              />

            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="input-title mb-3">
                  Place of Birth <span className="text-[#c00000]">*</span>
                </h2>
                <MultiSelectDropdown
                  drpIdentity="Place_Of_Birth"
                  options={props.birthPlaceList}
                  // isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={props.handleChangeSelectorDropdown}
                  allowSelectAll={false}
                  value={props.birthPlaceList.filter(
                    (birthPlace) =>
                      birthPlace.value ===
                      props.basicApplicationDetails.placeOfBirthId
                  )}
                />
              </div>
            </div>
            {/* <Validation error={props.validState.error.projectTypeId} /> */}
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="input-title mb-3">
                  Nationality <span className="text-[#c00000]">*</span>
                </h2>
                <MultiSelectDropdown
                  drpIdentity="Selected_Nationality"
                  options={props.nationalityList}
                  // isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={props.handleChangeSelectorDropdown}
                  allowSelectAll={false}
                  value={props.nationalityList.filter(
                    (nationality) =>
                      nationality.value ===
                      props.basicApplicationDetails.nationalityId
                  )}
                />
              </div>
            </div>
            {/* <Validation error={props.validState.error.projectTypeId} /> */}
          </div>

          <div className="xl:col-span-12 lg:col-span-12 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="input-title mb-3">
                  Upload Full Face Photo/Passport Photo <span className="text-[#c00000]">*</span>
                </h2>
                <div className="dropdown">
                  <div className="select-dropdown w-full">
                    {props && !props.basicApplicationDetails.photoFilePath ? (
                      <form className="custom-uploader custom-file-upload-btn flex cursor-pointer">
                        <ImageCropperWithUpload
                          key="Main"
                          height={10}
                          width={10}
                          isCheckValidation={true}
                          MaxFileSize={2097152}
                          MaxFileSizeMessage={"2 MB"}
                          onSaveImage={props.saveMainImage}
                          imageIdentity="CPASMemberData"
                          intitImage={
                            props.basicApplicationDetails.photoFilePath
                          }
                          aspactRatio={550 / 550}
                          uploadBtn={"Upload Photo"}
                          // className="sr-only"
                          id={`Upload_Full_Face_Photo`}
                          type="file"
                        />
                      </form>
                    ) : (
                      <button
                        className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                        style={{ borderColor: '#005b9c' }}
                        onClick={() => {
                          window.open(
                            APIURL +
                            GetImage +
                            "?type=Upload_Full_Face_Photo&&fileName=" +
                            props.basicApplicationDetails?.photoFilePath,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        <span className="text-xl font-semibold tracking-normal underline">
                          View Photo/Passport Photo
                        </span>
                      </button>
                    )}
                    {props && !props.basicApplicationDetails.photoFilePath ? (
                      <ValidationText
                        error={
                          props.validStateBasicApplication.error.photoFilePath
                        }
                      />
                    ) : null}
                    {props && props.basicApplicationDetails.photoFilePath ? (
                      <div className="mt-5 file-uploaded-txt flex items-center">
                        <img
                          src="/check-caps.png"
                          className="w-[25px] mr-3"
                          alt=""
                        ></img>
                        <span className="text-[#000]">
                          {props.basicApplicationDetails.photoFilePath}
                        </span>
                        <button
                          className="underline text-[#e74c3c] font-[500] ml-3"
                          onClick={() =>
                            props.deleteFile("", "Upload_Full_Face_Photo")
                          }
                        >
                          <i className="fa fa-trash" aria-hidden="true" style={{ color: "#005b9c" }}></i>
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {/* <Validation error={props.validState.error.projectTypeId} /> */}
          </div>
          <div className="col-span-12 mt-10">
            <div className="flex justify-end">
              {props && props.isLoading ? (
                <ButtonLoader type="btn btn-caps" />
              ) : (
                <button
                  className="btn btn-caps"
                  onClick={() =>
                    props.submitBasicApplication("BasicApplication")
                  }
                >
                  <span className="">Save</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
export default BasicApplication;
